/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import HR from '@zg-rentals/multibrand-ui/lib/HR';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import pathsManifest from '../../../pathsManifest';
import queryUtil from '../../../utils/queryUtils';

export default function MoveInFeedbackSuccessPage() {
  const { brand, routerLocation } = useSelector((state) => ({
    brand: state.app.brand,
    routerLocation: state.router.location.search,
  }));

  const currentQuery = queryUtil.parse(routerLocation);
  const [displayCometPayment, setDisplayCometPayment] = useState(true);
  const handleDisplayCometPayment = () => setDisplayCometPayment(!currentQuery.isMultiFamily);
  const handleUpdateEmail = () => window.open(pathsManifest[brand].preferenceSetting);
  const handleCometPayment = () => window.open(`https://www.${brand}.com${pathsManifest.paymentsPage}`);

  useEffect(() => {
    handleDisplayCometPayment();
  }, []);

  return (
    <Container className="stacked-children-sm stacked-lg" style={{ marginBottom: '300px', marginTop: '30px' }}>
      <Row>
        <Col>
          <Text type="h1" emphasize>
            Congratulations!
          </Text>
        </Col>
      </Row>
      <Row>
        <Col m={8}>
          <Text type="body">
            Since you found a place, you may be ready to stop receiving emails about property updates and
            recommendations.
          </Text>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={6} md={5} lg={4}>
          <Button type="primary" full onClick={handleUpdateEmail}>
            Update email preferences
          </Button>
        </Col>
      </Row>
      {displayCometPayment && (
        <React.Fragment>
          <Row>
            <Col>
              <HR type="h3" />
            </Col>
          </Row>
          <Row>
            <Col>
              <Text type="h1" emphasize>
                Next step? Pay your rent online
              </Text>
            </Col>
          </Row>
          <Row>
            <Col>
              <Text type="body">
                Now that you&apos;re moving in, would you like to automate your rent payments? Zillow offers online rent
                payments, a secure and convenient way to pay your landlord.
              </Text>
              <Text type="body">If your landlord is not yet signed up, simply invite them to get started.</Text>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={4} md={3} lg={2}>
              <Button type="primary" full onClick={handleCometPayment}>
                Learn more
              </Button>
            </Col>
          </Row>
        </React.Fragment>
      )}
    </Container>
  );
}
